export const config = {
  app: {
    name: process.env['NEXT_PUBLIC_APP_NAME'] || 'RockTheSport',
    url: process.env['NEXT_PUBLIC_APP_URL'] || 'http://localhost:3000',
    env: process.env['NODE_ENV'] || 'development',
    defaultCountryId: '65',
    countryCookieName: 'countryId',
    defaultImage: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/card/maraton.jpeg',
    images: {
      og: '/images/og-default.jpg',
      home: '/images/home-banner.jpg',
      events: '/images/events-banner.jpg'
    },
    sportImages: {
      // Images for cards
      card: {
        maraton: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/card/maraton.jpeg',
        running: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/card/maraton.jpeg',
        athletics: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/card/maraton.jpeg',
        cycling: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/card/cycling.jpeg',
        btt: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/card/btt.jpeg',
        mtb: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/card/btt.jpeg',
        tennis: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/card/tennis.jpeg',
        swimming: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/card/swimming.jpeg',
        skating: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/card/skating.jpeg',
        padel: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/card/padel.jpeg',
        zumba: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/card/zumba.jpeg',
        default: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/card/maraton.jpeg',
        triathlon: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/card/triathlon.jpeg',
        trail: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/card/trail.jpeg',
      },
      // Images for thumbnails
      thumb: {
        maraton: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/thumb/maraton.jpeg',
        running: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/thumb/maraton.jpeg',
        athletics: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/thumb/maraton.jpeg',
        cycling: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/thumb/cycling.jpeg',
        btt: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/thumb/btt.jpeg',
        mtb: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/thumb/btt.jpeg',
        tennis: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/thumb/tennis.jpeg',
        swimming: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/thumb/swimming.jpeg',
        skating: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/thumb/skating.jpeg',
        padel: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/thumb/padel.jpeg',
        zumba: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/thumb/zumba.jpeg',
        default: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/thumb/maraton.jpeg',
        triathlon: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/thumb/triathlon.jpeg',
        trail: 'https://rtsfiles.blob.core.windows.net/athlete/app/default/thumb/trail.jpeg',
      }
    }
  },
  i18n: {
    // Idioma al que cae `/` cuando no hay cookie ni Accept-Language reconocible, y destino del
    // `x-default` (lib/seo/canonical los deriva de aquí, para que no puedan divergir).
    // España concentra ~95% de la actividad, así que la raíz del dominio va a la home española.
    defaultLocale: process.env['NEXT_PUBLIC_DEFAULT_LOCALE'] || 'es',
    locales: ['es', 'en', 'pt', 'ca', 'eu', 'fr', 'it'] as const,
    localStorageKey: 'preferred_language',
    languages: {
      'es': {
        code: 'es',
        locale: 'es_ES',
        hreflang: 'es',
        path: '/es'
      },
      'en': {
        code: 'en',
        locale: 'en_US',
        hreflang: 'en',
        path: '/en'
      },
      'pt': {
        code: 'pt',
        // Portugal, no Brasil: `pt-BR` dirigía estas URLs al mercado equivocado. Coincide ya con
        // el LANG_TO_LOCALE de lib/event-og.ts, que siempre usó 'pt-PT'.
        locale: 'pt_PT',
        hreflang: 'pt-PT',
        path: '/pt'
      },
      'ca': {
        code: 'ca',
        locale: 'ca_ES',
        hreflang: 'ca',
        path: '/ca'
      },
      'eu': {
        code: 'eu',
        locale: 'eu_ES',
        hreflang: 'eu',
        path: '/eu'
      },
      'fr': {
        code: 'fr',
        locale: 'fr_FR',
        hreflang: 'fr',
        path: '/fr'
      },
      'it': {
        code: 'it',
        locale: 'it_IT',
        hreflang: 'it',
        path: '/it'
      }
    }
  },
  theme: {
    defaultTheme: process.env['NEXT_PUBLIC_DEFAULT_THEME'] || 'light',
    localStorageKey: 'theme'
  },
  api: {
    url: process.env['NEXT_PUBLIC_API_URL'] || 'http://localhost:5600',
    timeout: Number(process.env['NEXT_PUBLIC_API_TIMEOUT']) || 30000,
    apiKey: process.env['NEXT_PUBLIC_API_KEY'] || '',
    storage: {
      config: {
        container: 'configuracion/webnext',
        blob: 'globals.css'
      },
      images: {
        domains: [
          'localhost',
          'rtsfiles.blob.core.windows.net',
          'rockthesportv2.blob.core.windows.net'
        ]
      }
    }
  },
  seo: {
    googleSiteVerification: process.env['NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION'],
    twitter: {
      handle: '@rockthesport',
      site: '@rockthesport',
      card: 'summary_large_image'
    },
    openGraph: {
      type: 'website',
      imageWidth: 1200,
      imageHeight: 630
    }
  },
  recaptcha: {
    siteKey: process.env['NEXT_PUBLIC_RECAPTCHA_SITE_KEY_ID'] || '6LcpJxkrAAAAAPGP6uE-Lm0JqoRSrns3gUSouBLn'
  },
  tracking: {
    // Interruptor SOLO de desarrollo para poder probar el embudo de Facebook CAPI en local.
    //
    // El consentimiento de publicidad lo gestiona CookieYes, que entra por Google Tag Manager y
    // solo se sirve en los dominios dados de alta en su cuenta: en `localhost` el banner nunca
    // aparece, la cookie `cookieyes-consent` no existe y por tanto NINGÚN evento CAPI se llega a
    // enviar (ViewContent, InitiateCheckout, Search, Purchase).
    //
    // Con `NEXT_PUBLIC_FB_CAPI_DEV_CONSENT=true` en `.env.local` se da el consentimiento por
    // concedido y los eventos salen. Lo consume `hasAdvertisementConsent()`, que además exige
    // `NODE_ENV === 'development'`: en QA y producción manda siempre la cookie real, aunque la
    // variable se colase en el build.
    //
    // Es una variable `NEXT_PUBLIC_*`, así que se inlinea en tiempo de compilación: hay que
    // reiniciar `npm run dev` tras cambiarla.
    facebookCapiDevConsent: process.env['NEXT_PUBLIC_FB_CAPI_DEV_CONSENT'] === 'true',
    // Equivalente para los eventos de GA4 (`@/utils/analytics`), que dependen de la categoría
    // `analytics` de CookieYes en lugar de `advertisement`. Mismo motivo y mismas reglas: en
    // `localhost` no hay banner, así que sin esto no se puede ver un `purchase` en la vista previa
    // de GTM. Lo consume `hasAnalyticsConsent()`, que además exige `NODE_ENV === 'development'`.
    analyticsDevConsent: process.env['NEXT_PUBLIC_ANALYTICS_DEV_CONSENT'] === 'true',
  },
  emailChange: {
    // Tiempo de espera en segundos para poder reenviar un email de confirmación de cambio de email
    resendCooldownSeconds: 120,
    // Tiempo de expiración del token en minutos
    tokenExpirationMinutes: 20
  },
  passwordChange: {
    // Tiempo de espera en segundos para poder reenviar un email de confirmación de cambio de contraseña
    resendCooldownSeconds: 120,
    // Tiempo de expiración del token en minutos
    tokenExpirationMinutes: 20
  },
  chatbot: {
    url: process.env['NEXT_PUBLIC_CHATBOT_URL'] || 'https://automation.rockthesport.com/webhook/some_webhookId',
    user: process.env['NEXT_PUBLIC_CHATBOT_USER'] || 'chatbot',
    password: process.env['NEXT_PUBLIC_CHATBOT_PASSWORD'] || 'chatbot_password',
  },
  reservation: {
    apiUrl: process.env['NEXT_PUBLIC_API_URL'] || 'http://localhost:5600',
    timeout: Number(process.env['NEXT_PUBLIC_RESERVATION_TIMEOUT']) || 30000,
    // Cadencia con la que el hook `useReservation` EVALÚA si toca sondear el estado de la reserva.
    // No es una llamada garantizada cada tick: el sondeo real solo sale en la ventana crítica del
    // contador o cuando vence el latido (ver `pollingNearExpirySeconds` / `pollingHeartbeatMs`),
    // y nunca con la pestaña en background.
    //
    // Estaba en 5000 y sondeaba SIEMPRE: ~120 llamadas por usuario y sesión de formulario, cada una
    // resolviéndose en el backend como una lectura del documento completo de la reserva. Con miles
    // de inscripciones simultáneas en la apertura de un evento eso era, de largo, la mayor carga
    // del flujo — y toda contra la misma partición lógica de Cosmos (`reservation:{eventId}`).
    pollingIntervalMs: 30000,
    // Ventana crítica: últimos N segundos del contador. Aquí sí interesa preguntar al servidor en
    // cada tick, porque es donde se decide si la reserva sigue viva (p. ej. la extendieron desde
    // otra pestaña) y donde el usuario está a punto de perder la plaza.
    pollingNearExpirySeconds: 60,
    // Fuera de la ventana crítica, red de seguridad para enterarse de cambios que el contador local
    // no puede deducir: la reserva se completó o se canceló desde otra pestaña. El caso normal ya
    // lo cubre el countdown local, que no cuesta nada.
    pollingHeartbeatMs: 180000,
    durationSeconds: 600, // 10 minutos de reserva
    anonymousIdKey: 'rts_anonymous_id', // Key para localStorage
  }
} as const; 